import { BoolString } from '@/../../package-vhk/src/interface/KKC/withdrawal';
import { QuestionDto } from '../../../package-vhk/src/interface/pub';
import { PRODUCT_ARRAY } from '../interface/common';
import request, { Options } from '../utils/requests/request';
import { creditApply } from './interface/vertify';

// 上传pdf的时候涉及到的
export enum BusinessSource {
  CREDIT = '1', // 授信
  WITHDRAWAL = '2', // 放款
  BILLMGMT = '3', // 账单管理
  KKCAppeal = '4', // KKC的提额
}

//从businesssource拓展
export enum NewBusinessSource {
  CREDIT = '1', // 授信
  WITHDRAWAL = '2', // 放款
  BILLMGMT = '3', // 账单管理
  KKCAppeal = '4', // KKC的提额

  NEW_CREDIT = '7', //cl授信
  NEW_LOAN = '8', //cl提现
  NEW_IMPROVE_LIMIT = '9', //cl提额
}

// 查询所有产品信息
export const introduction = () =>
  request.post<{ product: Array<PRODUCT_ARRAY> }>('credit/product/introduction');

// 查询账单管理-FAQ
export const billIntroduction = () => request.post<Array<QuestionDto>>('credit/bill/introduction');

// 查询 MGM-FAQ
export const mgmIntroduction = () => request.post<Array<QuestionDto>>('credit/mgm/introduction');

export const searchcode = (fillInItems: any) => request.post('credit/code/search', fillInItems);
// export const searchcode = (loanAmt: any, repaymentNumber: any) =>
// request.post('credit/product/loan/calculator', {
//   params: { loanAmt, repaymentNumber },
// });
// 贷款计算器  String(numFormat(hkd))
export const mathrepaymentNumber = (fillInItems: any) =>
  request.post<{
    max: number;
    min: number;
    interestCategory: string;
  }>('credit/nl/product/loan/calculator', fillInItems);

// 查询节点信息
export const selectInfo = (fillInItems: any) =>
  request.post<creditApply>('credit/apply/select/info', fillInItems);
// 查询节点信息
export const selectNode = (fillInItems: any) =>
  request.post<{
    state: string | number;
    isPwd: string | undefined;
    isSms: string;
    auditReason: string;
  }>('credit/apply/select/node', fillInItems);

// 查询授信结果信息
export const searchType = (fillInItems: any) => request.post(`credit/apply/search/${fillInItems}`);

// 爬虫银行信息
export const crawlerInfo = (fillInItems: any) =>
  request.post<{
    isLast: number;
    isOpt: number;
    token: string;
    code: string | number;
    orderId?: string;
  }>('credit/apply/crawler/bank/info', fillInItems, { loading: true });

export const crawlerWithVerifyCode = (fillInItems: { id: string; securityPassword: string }) =>
  request.post<{
    isLast: number;
    isOpt: number;
  }>('credit/apply/crawler/bank/info/collect', fillInItems);

// 爬虫完成调用授信
export const checkInfo = (fillInItems: any) =>
  request.post<{
    auditReason: string;
    loanAmt: number;
    state: string | number;
  }>('credit/apply/decision/deliverable', fillInItems);

// 查询银行爬虫任务状态
export const checkbankInfostate = (fillInItems: { id: string; businessSource: BusinessSource }) =>
  request.post<{
    code: number;
    msg: string;
    bankCode: string;

    // 手机号后四位
    phoneLastDigits?: string;

    token: string;
  }>('credit/apply/crawler/bank/info/state', fillInItems);

// 发送手机尾号
export const sendPhoneLastDigits = (fillInItems: { businessId: string; phoneLastDigits: string }) =>
  request.post('credit/apply/crawler/bank/info/collect/digits', fillInItems);

export const searchSuccess = () => request.post<{ loanAmt: number }>('credit/apply/search/success');

// pdf 点击完成
export const pdfsuccess = (fillInItems: any) =>
  request.post('credit/apply/bank/statement/info/success', fillInItems);
// 上传后文件后提交PDF解析任务
// export const searchstatement = (fillInItems: any) =>
//   request.post<{
//     id: string | number;
//     bankName: string;
//     fileId: string;
//     filePath: string;
//     fileName: string;
//     index: number;
//   }>('credit/apply/bank/statement/info', fillInItems);

export const searchstatement = (fillInItems: any) =>
  request.post<{
    id: string | number;
    bankName: string;
    fileId: string;
    filePath: string;
    fileName: string;
    index: number;
    orderId?: string;
  }>('credit/apply/bank/statement/info', fillInItems);

export type searchavlResType = {
  auditReason: string;
  loanAmt: number; // 可用额度
  state: string;
  applyId: string;
  creditAmt: number; // 获批额度
  expireTime: string; // 可用时间
};
// 查询可用额度
export const searchavl = (fillInItems: any) =>
  request.post<searchavlResType>('credit/apply/search/avl', fillInItems);

// 查询授信失败原因
export const searchreason = (fillInItems: any) =>
  request.post<{
    auditReason: string;
    loanAmt: string | number;
    state: string;
  }>('credit/apply/search/reason', fillInItems);

// 初始化还款卡
export const bindinginitiate = (fillInItems: {
  bankCardNumEncrypt: string;
  bankEnName: string;
  bankId: string;
  bankName: string;
  bankNum: string;
  msgId?: string;
  type?: number;
  userId?: string;
  userName: string;
  productCode: string;
}) =>
  request.post<{
    msgId: string;
  }>('credit/binding/initiate', fillInItems, {}, { productCode: fillInItems.productCode });

// 初始化还款卡
export const bindingNewInitiate = (fillInItems: {
  bankCardNumEncrypt: string;
  bankEnName: string;
  bankId: string;
  bankName: string;
  bankNum: string;
  msgId?: string;
  type?: number;
  userId?: string;
  userName: string;
  productCode: string;
}) =>
  request.post<{
    msgId: string;
    eddaApplyId?: string;
    isTopHsbcOtp?: BoolString;
  }>('credit/binding/new-initiate', fillInItems, {}, { productCode: fillInItems.productCode });

// 查询银行列表
export const selectBankInfo = (fillInItems: {
  bankId?: string;
  bankName?: string;
  bankEnName?: string;
}) => request.post('credit/binding/selectBankInfo', fillInItems);

// 查询用户绑卡记录
export const selectCardInfo = (fillInItems: any, options?: Options) =>
  request.post<Array<any>>('credit/binding/selectCardInfo', fillInItems, options);

// 查询初始化或解绑还款卡状态
export const selectInitiate = (fillInItems: { msgId: string; type: number }) =>
  request.post<any>('credit/binding/selectInitiate', fillInItems);

// 解绑还款卡
export const updatebinding = (fillInItems: { msgId: string }) =>
  request.post<{
    msgId: string;
  }>('credit/binding/update', fillInItems);
